import React, { useState } from "react";
import axios from "axios";
import endpoints from "../config";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from '../context/AuthContext';
function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState(""); 
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await axios.post(endpoints.auth.login, { email, password });
      const token = res.data.access_token;
      login(token);
      navigate('/dashboard');
    } catch (err) {
      toast.error("Unable to login!");
    }
  };
  
  return (
    <div className="container mt-5">
    <div className="card p-4">
        <h4>Admin Login</h4>
        <input className="form-control my-2" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" />
        <input className="form-control my-2" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" />
      <button className="btn btn-primary" onClick={handleLogin}>Login</button>
      </div>
    </div>
  );
}

export default LoginForm;
